import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import storage from '#utils/local-storage';
import { authApi } from '#services/auth';

type AuthState = ReturnType<typeof storage.get>;

const handleAllPending = (state: AuthState) => {
  state.isLoginPending = true;
};

const handleLoginFulfilled = (state: AuthState, action: PayloadAction<unknown>) => {
  // workaround for reload page on login feature
  // do not modify the state to prevent the ui rerendering
  // let the browser reload for displaying the landing page
  const nextState = {
    isLoginPending: false,
    loginError: '',
    isLoggedIn: true,
    userInfo: action.payload,
  };
  storage.persist(nextState as AuthState);

  // state.isLoginPending = false;
  // state.loginError = '';
  // state.isLoggedIn = true;
  // state.userInfo = action.payload;
  // storage.persist(state);
};

const handleLoginRejected = (state: AuthState, action: PayloadAction<unknown>) => {
  state.isLoginPending = false;
  state.loginError = (action.payload as { data: { message: string } }).data.message;
  state.isLoggedIn = false;
  state.userInfo = null;
  storage.persist(state);
};

export const authSlice = createSlice({
  name: 'auth',
  initialState: storage.get(),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(authApi.endpoints.check.matchPending, handleAllPending)
      .addMatcher(authApi.endpoints.check.matchFulfilled, handleLoginFulfilled)
      .addMatcher(authApi.endpoints.check.matchRejected, handleLoginRejected)

      .addMatcher(authApi.endpoints.login.matchPending, handleAllPending)
      .addMatcher(authApi.endpoints.login.matchFulfilled, handleLoginFulfilled)
      .addMatcher(authApi.endpoints.login.matchRejected, handleLoginRejected)

      .addMatcher(authApi.endpoints.logout.matchPending, handleAllPending)
      .addMatcher(authApi.endpoints.logout.matchFulfilled, (state, _action) => {
        state.isLoginPending = false;
        state.loginError = '';
        state.isLoggedIn = false;
        state.userInfo = null;
        storage.persist(state);
      })
      .addMatcher(authApi.endpoints.logout.matchRejected, handleLoginRejected);
  },
});

export default authSlice.reducer;
